"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaxonomyOperationsImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing TaxonomyOperations operations. */
var TaxonomyOperationsImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class TaxonomyOperations class.
   * @param client Reference to the service client
   */
  function TaxonomyOperationsImpl(client) {
    (0, _classCallCheck2["default"])(this, TaxonomyOperationsImpl);
    this.client = client;
  }
  /**
   * @param portalId
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(TaxonomyOperationsImpl, [{
    key: "getTaxonomies",
    value: function getTaxonomies(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getTaxonomiesOperationSpec);
    }
    /**
     * @param portalId
     * @param taxonomyName
     * @param options The options parameters.
     */

  }, {
    key: "getPortalTaxonomy",
    value: function getPortalTaxonomy(portalId, taxonomyName, options) {
      var operationArguments = {
        portalId: portalId,
        taxonomyName: taxonomyName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getPortalTaxonomyOperationSpec);
    }
  }]);
  return TaxonomyOperationsImpl;
}(); // Operation Specifications


exports.TaxonomyOperationsImpl = TaxonomyOperationsImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getTaxonomiesOperationSpec = {
  path: "/api/v1/portals/{portalId}/taxonomies",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Taxonomy"
            }
          }
        }
      }
    }
  },
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getPortalTaxonomyOperationSpec = {
  path: "/api/v1/portals/{portalId}/taxonomies/{taxonomyName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.Taxonomy
    }
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.taxonomyName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};